import types from './types';

function simulatorReducer(state, action) {
  switch(action.type) {
    case types.SET_DESK:
      return {...state, desk: action.desk}
    case types.SET_COMPLETE_NAME:
      return {...state, clientData: {...state.clientData, nombreCompleto: action.nombreCompleto}}
    case types.SET_CLIENT_DATA:
      return {...state, clientData: action.clientData}
    case types.SET_IDENTIFICATION_TYPE:
      return {...state, clientData: {...state.clientData, tipoIdentificacion: action.tipoIdentificacion, identificacion: action.identificacion}}
    case types.SET_YEARS_OLD_BY_DATE:
      return {...state, clientData: {...state.clientData, edad: action.edad}}
    case types.SET_FECHA_NASCIMENTO:
      return {...state, clientData: {...state.clientData, fechaNacimiento: action.fechaNacimiento}}
    case types.SET_ACTIVITIE:
      return {...state, clientData: {...state.clientData, actividadCliente: action.actividadCliente}}
    case types.SET_PAYMENT_BILL:
      return {...state, clientData: {...state.clientData, pagaduria: action.pagaduria}}
    case types.SET_CONTACT_MEAN:
      return {...state, clientData: {...state.clientData, medioContacto: action.medioContacto}}
    case types.SET_IDENTIFICATION:
      return {...state, clientData: {...state.clientData, identificacion: action.identificacion}}
    case types.SET_PRICE_VALUE_TO_SOLICITATE:
      return {...state, priceValueToSolicitate: action.priceValueToSolicitate}
    case types.SET_DAYS_OF_INITIAL_INTEREST:
      return {...state, priceValueToSolicitate: {...state.priceValueToSolicitate, diasInteresesIniciales: action.diasInteresesIniciales}}
    case types.SET_MONTO:
      return {...state, priceValueToSolicitate: {...state.priceValueToSolicitate, monto: action.monto}}
    case types.SET_DEADLINE:
      return {...state, priceValueToSolicitate: {...state.priceValueToSolicitate, plazo: action.plazo}}
    case types.SET_RATE:
      return {...state, priceValueToSolicitate: {...state.priceValueToSolicitate, tasa: action.tasa}}
    case types.SET_LINE_OF_CREDIT:
      return {...state, financesData: {...state.financesData, lineaCredito: action.lineaCredito}}
    case types.SET_VALUE_FIELDS_OF_FINANCES:
      return {...state, financesData: {...state.financesData, ingresos: action.ingresos, descuentosNomina: action.descuentosNomina, descuentosLey: action.descuentosLey}}
    case types.SET_CREDIT_CHECKBOX:
      return {...state, financesData: {...state.financesData, credits: action.credits}}
    case types.SET_FIELDS:
      return {...state, financesData: {...state.financesData, fields: action.fields}}
    case types.ADD_FIELD:
      return {...state, financesData: {...state.financesData, fields: [...state.financesData.fields, action.field]}}
    case types.SET_DEFAULT_CREDIT:
      return {...state, financesData: {...state.financesData, credits: action.credits}}
    case types.SET_DEFAULT_INPUT:
      return {...state, financesData: {...state.financesData, fields: action.fields}}
    case types.SET_SIMULATION:
      return {...state, simulation: action.simulation}
    case types.SET_SIMULATION1:
      return {...state, simulation1: action.simulation1}
    case types.SET_SAVED_SIMULATION:
      return {...state, clientData: action.clientData, priceValueToSolicitate: action.priceValueToSolicitate, financesData: action.financesData}
    case types.SET_CREDIT_DESTINATION:
      return {...state, financesData: {...state.financesData, destinoCredito: action.destinoCredito}}
    case types.SET_SELECTED_STATE:
      return {...state, clientData: {...state.clientData, departamento: action.state }}
    case types.SET_SELECTED_CITY:
      return {...state, clientData: {...state.clientData, ciudad: action.city }}
    case types.SET_EDUCATIONAL_LEVEL:
      return {...state, priceValueToSolicitate: {...state.priceValueToSolicitate, nivelEscolaridad: action.nivelEscolaridad}}
    case types.SET_CONTRACT_TYPE:
      return {...state, priceValueToSolicitate: {...state.priceValueToSolicitate, tipoContrato: action.tipoContrato}}
    case types.SET_TAKER_GENDER:
      return {...state, clientData: {...state.clientData, genero: action.genero}}
    case types.SET_EXTRACT:
      return {...state, clientData: {...state.clientData, estrato: action.estrato}}
    case types.SET_PRODUCT:
        return {...state, priceValueToSolicitate: {...state.priceValueToSolicitate, pricingProduct: action.pricingProduct}}
    case types.SET_PRODUCT1:
      return {...state, priceValueToSolicitate: {...state.priceValueToSolicitate, pricingProduct1: action.pricingProduct1}}
    case types.SET_TASA:
      return {...state, priceValueToSolicitate: {...state.priceValueToSolicitate, pricingProduct: {...state.priceValueToSolicitate.pricingProduct, rate: action.rate}}}
    case types.SET_PRICING:
      return {...state, pricing: action.pricing}
    case types.SET_SELECTED_PAIS:
      return {...state, clientData: {...state.clientData, pais: action.pais }}
    case types.SET_SELECTED_DEPARTAMENTO:
      return {...state, clientData: {...state.clientData, departamento: action.departamento }}
    case types.SET_SELECTED_CIUDAD:
      return {...state, clientData: {...state.clientData, ciudad: action.ciudad }}
    case types.SET_DOMINIO_CORREO:
      return {...state, clientData: {...state.clientData, dominioCorreo: action.dominioCorreo}}
    case types.SET_DESTINO_CREDITO:
      return {...state, clientData: {...state.clientData, destinoCredito: action.destinoCredito}}
    case types.ADD_IDENTITY_PHOTO_FILE:
      return {...state, identityPhoto: [...state.identityPhoto, action.file[0]]}
    case types.SET_ID_TYPE:
      return {...state, clientData: {...state.clientData, tipoCedula: action.tipoCedula}}
    default:
      return state;
  }
}

export default simulatorReducer;
